import { reactive } from 'vue'
import { adminMe, adminLogin, adminLoginVerify, adminLoginResend, adminLogout } from './superadmin'

// Sesión del panel de superadmin: independiente de la sesión de clientes (otra cookie, otro backend).
const admin = reactive({ user: null, initialized: false })

let pending = null
function initAdmin() {
  if (admin.initialized) return Promise.resolve(admin.user)
  if (pending) return pending
  pending = adminMe()
    .then((user) => { admin.user = user; return user })
    .catch(() => { admin.user = null; return null })
    .finally(() => { admin.initialized = true; pending = null })
  return pending
}

// Con verificación en dos pasos activa, la contraseña correcta devuelve { twoFactorRequired, challengeId, email } y la sesión
// se abre hasta confirmar el código (verifyCode).
async function signIn(email, password) {
  const result = await adminLogin(email, password)
  if (result && result.twoFactorRequired) return result
  admin.user = result
  admin.initialized = true
  return result
}

async function verifyCode(challengeId, code) {
  const user = await adminLoginVerify(challengeId, code)
  admin.user = user
  admin.initialized = true
  return user
}

const resendCode = (email, password) => adminLoginResend(email, password)

async function signOut() {
  try { await adminLogout() } finally { admin.user = null }
}

export function useSuperadminStore() {
  return { admin, initAdmin, signIn, verifyCode, resendCode, signOut }
}